import { PageHeading, TeamHeading } from "@/components/Layout/Parts";
import ChannelsFilter from "@/components/ChannelsFilter";
import StrategyChangelogList from "./components/StrategyChangelogList";

const StrategyChangelog = () => {
  return (
    <>
      <TeamHeading />
      <PageHeading>Strategy Changelog</PageHeading>
      <ChannelsFilter />
      <StrategyChangelogList />
    </>
  );
};

export default StrategyChangelog;
